<template>
  <div>
    <VerifyTyc />
    <!-- <div v-if="this.$store.state.tyc == 1"><verifyPromo /></div> -->
    <v-overlay :value="overlay" style="height: 100vh">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <rollover-tracker v-if="promoActiva" :visible="promoActiva" :monto-bono="Number(promoData.montoBono)"
      :rollover="Number(promoData.rollover)" :apostado="Number(promoData.apostado)" moneda="UND "
      :loading="loadingCanje" :start-open="false" :transacciones="promoData.txs" @redeem="canjearBono" />
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" top right elevation="6">
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <iframe ref="gameFrame" :src="gameUrl" :style="size < 960
      ? 'width: 100%; height: calc(' + this.screenHeight * 0.93 + 'px)'
      : 'width: 100%; height: ' +
      (iframeIsGame ? 'calc(90vh)' : '93vh')
      " frameborder="0" allowfullscreen allow="fullscreen" @load="syncIframeUrlState"></iframe>

    <MisCuentas />
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import MisCuentas from "../components/MisCuentas.vue";
import misCuentas from "../components/MisCuentas.vue";
//import verifyPromo from "../components/VerifyPromo.vue";
import VerifyTyc from "../components/VerifyTyc.vue";
import RolloverTracker from "../components/RolloverTracker.vue";

export default {
  data() {
    return {
      gameUrl: null,
      promoData: null,
      overlay: true,
      promoActiva: false,
      snackbar: {
        show: false,
        text: "",
        color: "success",
      },
      loadingCanje: false,
      isMobile: 0,
      misCuentas,
      multiplicador: 1,
      mon: null,
      screenHeight: 0,

      // ✅ NUEVO: controla el height en desktop según URL interna del iframe
      iframeIsGame: false,

      // ✅ NUEVO: para detectar cambios de URL internos (SPA) en same-origin
      iframeUrlPoll: null,
      lastIframeHref: null,
    };
  },
  watch: {
    idmoneda() {
      this.overlay = true;
      this.getGame();
      //this.showChat();
    },
  },
  beforeDestroy() {

    this.detenerAutoUpdatePromo();
    if (typeof window === "undefined") return;
    window.removeEventListener("resize", this.onResize, { passive: true });
    window.removeEventListener("message", this.handleMessage);

    // ✅ limpiar polling
    if (this.iframeUrlPoll) {
      clearInterval(this.iframeUrlPoll);
      this.iframeUrlPoll = null;
    }
  },
  mounted() {
    this.screenHeight = window.innerHeight;
    this.isMobile = window.innerWidth < 600 ? 1 : 0;
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    window.addEventListener("message", this.handleMessage);
    this.checkbono();
    this.iniciarAutoUpdatePromo();

    axios({
      method: "post",
      url: `details`,
    }).then((response) => {
      this.$store.state.nombre = response.data.success.name;
    });

    this.getSaldo();

    if (document.getElementById("fc_frame")) {
      document.getElementById("fc_frame").style.display = "none";
    }

    this.idpos = sessionStorage.getItem("idpos");
    this.getGame();

    // ✅ iniciar polling (mismo dominio) para detectar cambios internos
    this.startIframeUrlPolling();
  },

  updated() {
    if (document.getElementById("fc_frame")) {
      document.getElementById("fc_frame").style.display = "none";
    }
  },
  methods: {
    ...mapActions(["getSaldo"]),
    onResize() {
      this.isMobile = window.innerWidth < 600 ? 1 : 0;
    },

    // ✅ lee la URL interna del iframe y ajusta iframeIsGame
    syncIframeUrlState() {
      try {
        const iframe = this.$refs.gameFrame;
        if (!iframe || !iframe.contentWindow) return;

        const href = (iframe.contentWindow.location.href || "").toLowerCase();
        this.lastIframeHref = href;
        this.iframeIsGame = href.includes("game");
      } catch (e) {
        // same-origin debería permitirlo; si por alguna razón no, no rompe
      }
    },

    // ✅ polling para SPAs que cambian URL sin recargar (no dispara load)
    startIframeUrlPolling() {
      if (this.iframeUrlPoll) return;

      this.iframeUrlPoll = setInterval(() => {
        try {
          const iframe = this.$refs.gameFrame;
          if (!iframe || !iframe.contentWindow) return;

          const href = (iframe.contentWindow.location.href || "").toLowerCase();
          if (href && href !== this.lastIframeHref) {
            this.lastIframeHref = href;
            this.iframeIsGame = href.includes("game");
          }
        } catch (e) {
          // same-origin debería permitirlo; si no, simplemente no actualiza
        }
      }, 300);
    },

    // --- MÉTODO ACTUALIZADO CON EL FILTRO DE EXTENSIONES ---
    handleMessage(event) {
      // 1. IGNORAR MENSAJES DE EXTENSIONES CONOCIDAS (MetaMask, React DevTools, Webpack, etc.)
      if (event.data && typeof event.data === 'object') {

        if (
          event.data.source === 'react-devtools-content-script' ||
          event.data.source === 'react-devtools-bridge' ||
          event.data.source === 'vue-devtools-backend-hook' ||
          event.data.key === '__VUE_DEVTOOLS_VUE_DETECTED_EVENT__' || // Nuevo de Vue
          event.data.target === 'metamask-inpage' ||
          event.data.target === 'metamask-contentscript' ||
          event.data.type === 'webpackOk' ||
          event.data.type === 'webpackClose' ||
          event.data.type === 'webpackWarnings' ||
          event.data.type === 'webpackInvalid'
        ) {
          return;
        }
      }

      // 2. BLOQUEAR MENSAJES DE FRESHCHAT
      if (event.origin === 'https://wchat.freshchat.com') {
        return;
      }

      // 2. AHORA SÍ, IMPRIMIMOS LO QUE QUEDA (Esperamos que sea del juego)
      console.log("-----------------------------------------");
      console.log("🔔 POSIBLE MENSAJE DEL IFRAME");
      console.log("Origen:", event.origin);
      console.log("Datos:", event.data);
      console.log("-----------------------------------------");
    },
    iniciarAutoUpdatePromo() {
      this.detenerAutoUpdatePromo();

      this.promoInterval = setInterval(() => {
        this.checkbono();
      }, 7000); // 10 segundos
    },

    detenerAutoUpdatePromo() {
      if (this.promoInterval) {
        clearInterval(this.promoInterval);
        this.promoInterval = null;
      }
    },

    async checkbono() {
      let bono = "";

      await axios.post("pragmaticbono/check").then((response) => {
        bono = response.data.message;
        this.promoData = response.data
      });
      if (bono == "Activo") {
        this.promoActiva = true;
      }


    },
    async canjearBono() {
      if (this.loadingCanje) return;

      this.loadingCanje = true;

      try {
        const res = await axios.post('pragmaticbono/canjear', {
          moneda: this.mon,
        });
        if (res.data.success) {

          this.$store.state.promocode == "";

          this.snackbar = {
            show: true,
            text: res.data.message || "Bono convertido a saldo real 🎉",
            color: "success",
          };
          //this.$toast.success(res.data.message || "Bono convertido a saldo real 🎉");


          // opcional: refrescar saldo/cuenta
          /*if (this.getUserInfo) {
            await this.getUserInfo();
          }*/

          // espera un poco para que el usuario vea el mensaje
          setTimeout(() => {
            this.promoActiva = false;
          }, 1200);


        } else {
          this.snackbar = {
            show: true,
            text: res.data.message || "No se pudo canjear",
            color: "error",
          };
        }

      } catch (e) {
        console.error(e);
        this.snackbar = {
          show: true,
          text: e?.response?.data?.message || "Error al canjear bono",
          color: "error",
        };
      } finally {
        this.loadingCanje = false;
      }
    },

    getGame() {
      const offsetHours = -new Date().getTimezoneOffset() / 60;
      this.mon = "";
      this.multiplicador = 1;

      if (this.$store.state.idmoneda == 1) {
        this.mon = "VES";
        this.multiplicador = 218;
      } else if (this.$store.state.idmoneda == 2) this.mon = "USD";
      else if (this.$store.state.idmoneda == 3) this.mon = "PEN";
      else if (this.$store.state.idmoneda == 7) this.mon = "COP";
      else if (this.$store.state.idmoneda == 8) this.mon = "CLP";

      axios({
        method: "post",
        url: `https://trackandraces.com/onlineapi/api/casino/login`,
        data: {
          moneda: this.mon,
          timezone: offsetHours,
        },
      }).then((response) => {
        console.log(response);
        const url = response.data.message;
        this.gameUrl = url;
        //alert("Las unidades de su Cartera seran convertidas en Bolivares para realizar las Jugadas");
        this.overlay = false;

        // ✅ intenta sincronizar apenas se renderiza el iframe
        this.$nextTick(() => this.syncIframeUrlState());
      });
    },
  },
  computed: {
    size() {
      return this.$store.state.windowSize.x;
    },
    moneda() {
      return this.$store.state.moneda;
    },
    idmoneda() {
      return this.$store.state.idmoneda;
    },
    idsb() {
      return this.$store.state.idsb;
    },
    currentBalance() {
      return this.$store.state.currentBalance;
    },
    idpos: {
      get() {
        return this.$store.state.idpos;
      },
      set(e) {
        this.$store.state.idpos = e;
      },
    },
  },
  components: { MisCuentas, VerifyTyc, RolloverTracker },
};
</script>

<style>
header {
  background-color: #fa22229a;
  border-radius: 5px;
  color: #fff;
  padding: 1px;
  margin-left: 6px;
  margin-right: 6px;
  margin-bottom: 3px;
}

nav ul {
  list-style: none;
  padding: 3px;
  margin: 0;
}

nav li {
  display: inline;
  /* Hace que los ítems del menú estén en una línea horizontal */
  margin-right: 20px;
  /* Espacio entre los ítems del menú */
}

nav a {
  text-decoration: none;
  color: #fff !important;
  font-size: 16px;
}

nav a:hover {
  font-size: 17px;
  color: #000 !important;
}
</style>
